import { Resource as a, API as c } from "@coveo/platform-client";
class s extends a {
  async put(e, t) {
    const r = `/commerceservice/restricted/organizations/${c.orgPlaceholder}/commerce/tracking-ids/${e}/feature-stack/configuration`;
    await this.api.put(r, t);
  }
}
export {
  s as FeatureStackConfiguration
};
//# sourceMappingURL=FeatureStackConfiguration.js.map
